// Inbox list tab
import * as Contacts      from '../contacts';
import * as Conversations from '../conversations';
import * as User          from '../user';
import { useDispatch }    from 'react-redux';
import InboxPage          from './inbox_page';
import React              from 'react';


export default function InboxTab({ businessID, conversationID }) {

  const dispatch      = useDispatch();
  const statuses      = Conversations.useConversationsStatuses(businessID);
  const currentUserID = User.useUserID();
  const conversations = Conversations.useConversations(businessID);

  function load() {
    dispatch(Contacts.readContactsPagination({ businessID }));
    dispatch(Conversations.readConversations({ businessID }));
  }

  return (
    <InboxPage key={businessID} {...{
      statuses,
      load,
      businessID,
      conversationID,
      currentUserID,
      conversations
    }}/>
  );
}
